import React, { useContext } from 'react';
import _, { isEmpty } from 'lodash';
import { Container } from './styles/Container.styled';
import { SectionPdf, RCard, PdfCard, PdfPart, PdfDetails } from './styles/PdfBlockSection.styled';
import { convertMonthToAr, dateToString } from '../helpers/date-convert';
import { DWTCContext } from '../utils/context';
import { getTranslationByKey } from '../helpers/translation-helper';

export default function Downloadables({ data, id, dir }) {
  const { translations } = useContext(DWTCContext);

  const getFileExtension = (url) => {
    const lastSegment = _.last(_.split(url, '.'));
    if (!lastSegment) return '';
    const queryIndex = _.includes(lastSegment, '?')
      ? _.indexOf(lastSegment, '?')
      : lastSegment.length;
    const hashIndex = _.includes(lastSegment, '#')
      ? _.indexOf(lastSegment, '#')
      : lastSegment.length;
    const endOfExtensionIndex = Math.min(queryIndex, hashIndex);
    return lastSegment.substring(0, endOfExtensionIndex);
  };

  const { cssClass } = useContext(DWTCContext);
  const isArabic = dir === 'rtl';
  return (
    <div id="downloadables">
      <SectionPdf id={id}>
        <Container>
          {_.isEmpty(data.showHeadline) || (
            <h2 dir={dir}>{getTranslationByKey(translations, 'Downloads')}</h2>
          )}

          {_.isEmpty(data) ||
            data.downloadables.map(({ content: { file, fileSize, date, description } }) => (
              <RCard>
                {_.isEmpty(file) || (
                  <PdfCard href={file.url} target="_blank">
                    <PdfPart dir={dir} className={cssClass}>
                      <i className="pdficon" />
                      <span className="has-phone">
                        {`${getFileExtension(file.url)} - ${fileSize}`}
                      </span>
                    </PdfPart>
                    <PdfDetails dir={dir}>
                      <time dir={dir}>
                        {isArabic ? convertMonthToAr(dateToString(date)) : dateToString(date)}
                      </time>
                      <h3 dir={dir}>{description}</h3>
                    </PdfDetails>
                  </PdfCard>
                )}
              </RCard>
            ))}
        </Container>
      </SectionPdf>
    </div>
  );
}

